/**
 * Swap array elements position
 *
 * @param {[]} arr
 * @param {number} fromIndex - First index.
 * @param {number} toIndex - Second index.
 * @return {array}
 */
export function reorder<T>(arr: Array<T>, fromIndex: number, toIndex: number): Array<T> {
  if (arr.length === 0) {
    return arr;
  }

  const copy = [...arr];
  const [removed] = copy.splice(fromIndex, 1);
  copy.splice(toIndex, 0, removed);
  return copy;
}
